import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders, HttpResponse } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { CacheStorage, CacheGroup } from '../../shared/services/cache-storage.service';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
//import { ApplicationStateService } from '@sms-app/shared';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(private authService: OAuthService,
    private cacheStorageService: CacheStorage//, private appState: ApplicationStateService
  ) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let token = (this.authService.getAccessToken() || '');
    var headers = new HttpHeaders({
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
    }).set('Authorization', 'Bearer ' + token);

    // add extra headers sent from the code
    req.headers.keys().forEach(key => {
      headers = headers.append(key, req.headers.get(key) || '');
    });

    const httpRequest = req.clone({headers: headers});
    var cachedResponse = this.processCacheStore(req);

    if (cachedResponse != null) {
      // for automation tests we need to mock ajax send by incrementing the counter
      // of(cachedResponse) will trigger the Response event and the counter will be decremented accordingly
   //   this.appState.incAjaxCounter();

      return of(cachedResponse);
    }
    return next.handle(httpRequest)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this.updateCacheStore(req, event);
          }
        })
      );
  }

  private processCacheStore(req: HttpRequest<any>) {
    if (req.method == 'GET' && req.headers.has("use-cache-store") && !this.forceCacheClear()) {
      var storedResponse = this.cacheStorageService.get(CacheGroup.Api, req.url);

      if (storedResponse) {
        // local storage changes the response type, so we have to manually construct it to HttpResponse
        return new HttpResponse({
          body: storedResponse.object.body,
          headers: storedResponse.object.headers,
          status: storedResponse.object.status,
          statusText: storedResponse.object.statusText,
          url: storedResponse.object.url
        })
      }
      return null;
    }
    return null;
  }

  private updateCacheStore(req: HttpRequest<any>, response: HttpResponse<any>) {
    if (req.method == 'GET' && response.status != 500 && req.headers.has("use-cache-store") && !this.forceCacheClear()) {
      var expiryValue = req.headers.get("use-cache-store");
      this.cacheStorageService.add(CacheGroup.Api, req.url, response, expiryValue);
    }
  }

  private forceCacheClear() {
    return /cacheclear/.test(window.location.href.toLocaleLowerCase());
  }
}
